var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { classNames } from '@shapeable/utils';
import { ComponentPropsProvider } from '../context/component-props-context';
import { ExplorerEntityDetailsLayoutDefaultProps } from '../explorer/explorer-entity-details-layout';
import { EntityExplorerLayout } from './entity-explorer-layout';
var cls = classNames('economy-explorer-layout');
export var EconomyExplorerLayoutDefaultProps = __assign(__assign({}, ExplorerEntityDetailsLayoutDefaultProps), {
  isAsideSticky: false,
  showAsideHeader: false
});
// -------- Child Component Props -------->
// -------- Styles -------->
// -------- Components -------->
var My = {};
export var EconomyExplorerLayout = function (props) {
  // const { entityTypeDefinitions } = useEntityTypeDefinitionsQuery(['Economy']);
  return React.createElement(ComponentPropsProvider, {
    value: {
      EntityBanner: {
        maxHeight: 300,
        fontTypes: {
          header: 'serif'
        },
        variant: 'image',
        showSubheader: true,
        useBackgroundColor: false,
        entityValueProps: {
          showImage: false,
          showOutlineNumber: false
        }
      }
    }
  }, React.createElement(EntityExplorerLayout, __assign({}, props)));
};
EconomyExplorerLayout.defaultProps = EconomyExplorerLayoutDefaultProps;
EconomyExplorerLayout.cls = cls;